import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as RiIcons from 'react-icons/ri';

const SafeIcon = ({ icon, name, lib = 'fi', ...props }) => {
  let IconComponent;
  try {
    if (icon) {
      IconComponent = icon;
    } else if (name) {
      if (lib === 'fi') IconComponent = FiIcons[`Fi${name}`];
      if (lib === 'ri') IconComponent = RiIcons[`Ri${name}`];
    }
  } catch (e) {
    IconComponent = null;
  }

  return IconComponent
    ? React.createElement(IconComponent, props)
    : <FiIcons.FiAlertTriangle {...props} />;
};

export default SafeIcon;